import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock, Mail, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream bg-adinkra px-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-white p-10 shadow-xl">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 font-display text-xl text-umber">
          <span className="grid h-8 w-8 place-items-center rounded-md bg-umber text-cream">S</span>
          SeedTech<span className="text-terracotta">NG</span>
        </Link>
        <h1 className="font-display text-3xl font-semibold text-umber">Staff sign in</h1>
        <p className="mt-2 text-sm text-umber/65">Reply to live chat conversations.</p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-umber/60">Email</label>
            <div className="mt-1 flex items-center gap-2 rounded-md border border-border bg-white px-3 py-2.5 focus-within:border-umber">
              <Mail className="h-4 w-4 text-umber/40" />
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent text-sm focus:outline-none"
                placeholder="admin@seeds.com3.ng"
              />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-umber/60">Password</label>
            <div className="mt-1 flex items-center gap-2 rounded-md border border-border bg-white px-3 py-2.5 focus-within:border-umber">
              <Lock className="h-4 w-4 text-umber/40" />
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="flex-1 bg-transparent text-sm focus:outline-none"
                placeholder="••••••••"
              />
            </div>
          </div>
          {error && (
            <div data-testid="admin-login-error" className="rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
              {error}
            </div>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-terracotta px-5 py-3 text-sm font-medium text-cream transition hover:bg-terracotta-dark disabled:opacity-50"
          >
            {loading ? "Signing in…" : (<>Sign in <ArrowRight className="h-4 w-4" /></>)}
          </button>
        </form>

        <Link to="/" className="mt-6 block text-center text-xs text-umber/50 hover:text-umber">
          ← Back to website
        </Link>
      </div>
    </div>
  );
}
